import React from 'react'
import BaseImgDisableBtn from './BaseImgDisableBtn'

import img from 'assets/img/ic-undo-disable.png'

const UndoDisableBtn = (props: any) => {
  return <BaseImgDisableBtn img={img} onClick={props.onClick} />
}

export default UndoDisableBtn
